import clsx from "clsx";
import SampleDetailsLink from "../../../../components/SampleDetailsLink";

import ThreatStatusLabel from "../../../../components/ThreatStatusLabel";
import { enums } from "../../../../shim/jsbridge";
import { isBlankOrHangulFiller } from "../../../../utils";

import { getNtiUrl } from "../../../samples/components/header/utils";
import { LOCATION } from "../../consts";
import PredictedFileNameLink from "./PredictedFileNameLink";

const { analyzer: { URLANALYZER = 1 } = {} } = enums || {};

type Props = {
  data: any;
  className?: string;
};

const Name = ({ data, className }: Props) => {
  const {
    sha1,
    threat_status: threatStatus,
    classification,
    location,
    reanalyzing,
    file_name,
    predicted_filename: predictedFilename,
    int_submission_analyzer: analyzer
  } = data || {};

  const isLocal = location === LOCATION.LOCAL;

  const filename =
    !file_name || isBlankOrHangulFiller(file_name) ? sha1 : file_name;

  if (isLocal && reanalyzing) {
    return (
      <ThreatStatusLabel
        showColor
        showOrb={false}
        threatStatus={threatStatus}
        labelText={filename}
      />
    );
  }

  const isUrl = analyzer === URLANALYZER;

  const sampleRecord = {
    sha1,
    threat_status: threatStatus,
    classification,
    filename,
    predictedFilename
  };

  const ntiURL = isUrl ? getNtiUrl(file_name) : undefined;
  return (
    <div
      className={clsx(
        "flex",
        "flex-column",
        "samples-grid__name-container",
        className
      )}
    >
      <SampleDetailsLink
        showTitle
        sampleRecord={sampleRecord}
        href={ntiURL}
        disabled={isUrl && !ntiURL}
      />
      <PredictedFileNameLink predictedFileName={predictedFilename} />
    </div>
  );
};

export default Name;
